<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Companies</h4>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-4">
              <BFormInput
                @input="applyFilters"
                v-model="filters.title"
                placeholder="Company Name"
              />
            </div>
            <div class="col-md-4">
              <BFormGroup>
                <BFormCheckbox
                  v-model="filters.withoutLinkedInId"
                  @input="applyFilters"
                  >Without LinkedIn Id</BFormCheckbox
                >
              </BFormGroup>
            </div>
            <div class="col-md-4">
              <BFormGroup>
                <BFormCheckbox
                  v-model="filters.hasPublishedOffer"
                  @input="applyFilters"
                  >Active Offer</BFormCheckbox
                >
              </BFormGroup>
            </div>
          </div>
          <div class="table-responsive">
            <BTable
              id="company-table"
              :items="companies"
              :fields="fields"
              :busy="isTableBusy"
            >
              <div slot="table-busy" class="text-center my-2">
                <BSpinner class="align-middle"></BSpinner>
              </div>
              <template v-slot:head()="data">
                <span class="text-info">{{ data.label }}</span>
              </template>
              <template v-slot:cell(company)="data">
                <div>
                  <img
                    v-if="data.item.logo"
                    :src="data.item.logo"
                    alt="company logo"
                    class="company-logo"
                  />
                  <a :href="getCompanyHref(data.item.id)" target="_blank">{{
                    data.item.name_fr
                  }}</a>
                </div>
              </template>
            </BTable>
            <BPagination
              v-if="showPagination"
              :disabled="isTableBusy"
              v-model="currentPage"
              @input="setCompanies"
              :total-rows="total"
              :per-page="perPage"
              align="center"
              aria-controls="company-table"
              class="mt-4"
            ></BPagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BTable,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BSpinner
} from "bootstrap-vue";

export default {
  components: {
    BTable,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BSpinner
  },
  data() {
    let currentPage = 1;
    let withoutLinkedInId = false;
    let hasPublishedOffer = false;
    if (this.$route.params.pageHistory) {
      if (this.$route.params.pageHistory.page) {
        currentPage = this.$route.params.pageHistory.page;
      }
      if (this.$route.params.pageHistory.filters) {
        if (this.$route.params.pageHistory.filters.withoutLinkedInId) {
          withoutLinkedInId = this.$route.params.pageHistory.filters
            .withoutLinkedInId;
        }
        if (this.$route.params.pageHistory.filters.hasPublishedOffer) {
          hasPublishedOffer = this.$route.params.pageHistory.filters
            .hasPublishedOffer;
        }
      }
    }
    return {
      companies: [],
      filters: {
        withoutLinkedInId,
        hasPublishedOffer
      },
      currentPage,
      perPage: 15,
      total: 0,
      isTableBusy: true,
      fields: [
        { key: "company", label: "company" },
        { key: "phone_number", label: "Phone" },
        { key: "is_agency", label: "Agency" },
        { key: "employee_count", label: "Employees" },
        { key: "sector", label: "Sector" },
        { key: "slug", label: "Carreer Slug" },
        { key: "linkedin_id", label: "LinkedIn Id" },
        { key: "created_at", label: "Created At" }
      ]
    };
  },
  computed: {
    pageHistory() {
      return {
        page: this.currentPage,
        filters: this.filters
      };
    },
    showPagination() {
      return this.companies.length && this.total > this.perPage;
    }
  },
  methods: {
    applyFilters() {
      this.currentPage = 1;
      this.setCompanies();
    },
    setCompanies() {
      this.isTableBusy = true;
      this.$http
        .get(`/enroll_admin/companies`, {
          params: {
            page: this.currentPage,
            per_page: this.perPage,
            filters: this.filters
          }
        })
        .then(({ data }) => {
          this.currentPage = data.current_page;
          this.total = data.total;
          this.companies = data.data;
        })
        .finally(() => (this.isTableBusy = false));
    },
    getCompanyHref(companyId) {
      const route = this.$router.resolve({
        name: "company",
        params: {
          companyId: companyId
        }
      });
      return route.href;
    }
  },
  created() {
    this.setCompanies();
  }
};
</script>
